import React, { useState, useEffect } from 'react'
import Select from 'react-select'

const SelectTime = (props) => {
  const hourOptions = Array.from({ length: 24 }, (_, i) => ({
    value: i.toString().padStart(2, '0'),
    label: i.toString().padStart(2, '0')
  }));

  const minuteOptions = Array.from({ length: 12 }, (_, i) => ({
    value: (i * 5).toString().padStart(2, '0'),
    label: (i * 5).toString().padStart(2, '0')
  }));

  const radioOptions = [
    { value: '23:58', label: 'なし' },
    { value: '04:01', label: '早朝' },
    { value: '12:01', label: '日中' },
    { value: '00:01', label: '夜間' },
    { value: '22:01', label: '深夜' },
    { value: 'custom', label: '時間を指定' }
  ]

  const [selectedHour, setSelectedHour] = useState(props.value || '');
  const [selectedMinute, setSelectedMinute] = useState(props.value || '');
  const [selectedRadio, setSelectedRadio] = useState(props.value || radioOptions[0].value)
  const [isCustomSelected, setIsCustomSelected] = useState(false);
  const [aboutTimeStart, setAboutTimeStart] = useState(props.easy_news.about_time_start || false);
  const [aboutTimeEnd, setAboutTimeEnd] = useState(props.easy_news.about_time_end || false);

  useEffect(() => {
    if (props.value) {
      const [hour, minute] = props.value.split(':');
      setSelectedHour(hour);
      setSelectedMinute(minute);
      if (radioOptions.find(option => option.value === props.value)) {
        setSelectedRadio(props.value || radioOptions[0].value);
        setIsCustomSelected(false);
        if (props.name === 'start_time') {
          setAboutTimeStart(false);
          props.onAboutTimeStartChange(false);
        } else if (props.name === 'end_time') {
          setAboutTimeEnd(false);
          props.onAboutTimeEndChange(false);
        }
      } else {
        setSelectedRadio('custom');
        setIsCustomSelected(true);
      }
    }
  }, [props.value, props.name, props.onAboutTimeStartChange, props.onAboutTimeEndChange]);

  const handleHourChange = (hour) => {
    setSelectedHour(hour.value);
    const newValue = `${hour.value}:${selectedMinute}`;
    props.onChange({ value: newValue, label: newValue });
  };

  const handleMinuteChange = (minute) => {
    setSelectedMinute(minute.value);
    const newValue = `${selectedHour}:${minute.value}`;
    props.onChange({ value: newValue, label: newValue });
  };

  const handleRadioChange = (event) => {
    const value = event.target.value;
    setSelectedRadio(value);
    setIsCustomSelected(value === 'custom');
    if (value !== 'custom') {
      const [hour, minute] = value.split(':');
      setSelectedHour(hour);
      setSelectedMinute(minute);
      props.onChange({ value, label: value });
    } else {
      setSelectedHour('09');
      setSelectedMinute('00');
      const customTime = '09:00';
      props.onChange({ value: customTime, label: customTime });
      setIsCustomSelected(true);
    }
  };

  const handleAboutTimeStartChange = (event) => {
    const {checked} = event.target;
    setAboutTimeStart(checked)
    props.onAboutTimeStartChange(checked)
  };
  const handleAboutTimeEndChange = (event) => {
    const {checked} = event.target;
    setAboutTimeEnd(checked)
    props.onAboutTimeEndChange(checked)
  };

  return (
    <div>
      <div className='selectTimeRadio'>
        {radioOptions.map((option) => (
          <div key={`${props.name}-${option.value}`} className={`radioOption ${option.value === 'custom' ? 'customRadio' : ''}`}>
            <input
              type="radio"
              id={`${props.name}-${option.value}`}
              name={`timeOption ${props.name ? props.name : ''}`}
              value={option.value}
              checked={selectedRadio === option.value}
              onChange={handleRadioChange}
            />
            <label htmlFor={`${props.name}-${option.value}`}>{option.label}</label>
          </div>
        ))}
        {selectedRadio === 'custom' && (
          <div className="customTimeSelect">
            <Select
              key={"select-hour-" + selectedHour}
              className="selectTimeForDayTime hour"
              name="easy_news[schedule_time_hour]"
              value={hourOptions.find((option) => option.value === selectedHour)}
              onChange={handleHourChange}
              options={hourOptions}
            />
            <span className='colon'>:</span>
            <Select
              key={"select-minute-" + selectedMinute}
              className="selectTimeForDayTime minutes"
              name="easy_news[schedule_time_minutes]"
              value={minuteOptions.find((option) => option.value === selectedMinute)}
              onChange={handleMinuteChange}
              options={minuteOptions}
            />
            {isCustomSelected && (props.name === 'start_time') && (
              <label htmlFor="easy_news[about_time_start]">
                <input
                  type="checkbox"
                  name="easy_news[about_time_start]"
                  id="easy_news[about_time_start]"
                  checked={aboutTimeStart}
                  onChange={handleAboutTimeStartChange} 
                />
                時刻表示に<b>「頃」</b>を付ける
              </label>
            )}
            {isCustomSelected && (props.name === 'end_time') && (
              <label htmlFor="easy_news[about_time_end]">
                <input
                  type="checkbox"
                  name="easy_news[about_time_end]"
                  id="easy_news[about_time_end]"
                  checked={aboutTimeEnd}
                  onChange={handleAboutTimeEndChange}
                />
                時刻表示に<b>「頃」</b>を付ける
              </label>
            )}
          </div>
        )}
      </div>
    </div>
  )
}

export default SelectTime
